import React from 'react';
import { useTranslation } from 'react-i18next';
import '../cpdpro.css';

export default function CpdProAbonnementenPage() {
  const { t } = useTranslation();

  return (
    <>
      <section className="cpd-page-hero">
        <div className="container">
          <h1>{t('cpd.subs.title', 'Abonnementen')}</h1>
          <p className="muted">{t('cpd.subs.subtitle', 'Choose the plan that fits your CPD needs.')}</p>
        </div>
      </section>

      <section className="cpd-pricing" style={{ paddingTop: '2rem' }}>
        <div className="container">
          <h2>{t('pricing.title', 'Choose Your Plan')}</h2>
          <p className="pricing-subtitle">{t('pricing.subtitle', 'Choose between formal CPD certification or flexible professional learning')}</p>

          <div className="pricing-grid">
            <div className="pricing-card">
              <div className="plan-header">
                <h3>{t('pricing.monthly.title', 'Professional Monthly')}</h3>
                <p className="plan-description">{t('pricing.monthly.desc', 'All Professional features with 1 CPD point/month allowance (rollover)')}</p>
                <div className="price">
                  <span className="amount">€19.99</span>
                  <span className="period">{t('perMonthExclVat', '/month (excl VAT)')}</span>
                </div>
              </div>
              <div className="features-list">
                <div className="feature"><span className="check-icon">✓</span><span>{t('pricing.feature.readUnlimited', 'Read unlimited articles across all professions')}</span></div>
                <div className="feature"><span className="check-icon">✓</span><span>{t('pricing.feature.monthlyAllowance', 'Earn official CPD points (2 per month allowance, rolls over)')}</span></div>
                <div className="feature"><span className="check-icon">✓</span><span>{t('pricing.feature.downloadCertificates', 'Download accredited certificates')}</span></div>
                <div className="feature"><span className="check-icon">✓</span><span>{t('pricing.feature.shortTests', 'Take short tests (5 AI-generated questions)')}</span></div>
                <div className="feature"><span className="check-icon">✓</span><span>{t('pricing.feature.trackProgress', 'Track progress and certification history')}</span></div>
              </div>
              <button className="btn-pricing" onClick={() => window.location.href = 'https://cpd-pro.app/'}>
                {t('launchPlatform', 'Launch Platform')}
              </button>
            </div>

            <div className="pricing-card">
              <div className="plan-badge most-popular">{t('mostPopular', 'Most Popular')}</div>
              <div className="plan-header">
                <h3>{t('pricing.professional.title', 'Professional')}</h3>
                <p className="plan-description">{t('pricing.professional.desc', 'For formal CPD certification and accredited learning')}</p>
                <div className="price">
                  <span className="amount">€199.99</span>
                  <span className="period">{t('perYearExclVat', '/year (excl VAT)')}</span>
                </div>
              </div>
              <div className="features-list">
                <div className="feature"><span className="check-icon">✓</span><span>{t('pricing.feature.readUnlimited', 'Read unlimited articles across all professions')}</span></div>
                <div className="feature"><span className="check-icon">✓</span><span>{t('pricing.feature.unlimitedPoints', 'Earn unlimited official CPD points worldwide')}</span></div>
                <div className="feature"><span className="check-icon">✓</span><span>{t('pricing.feature.downloadCertificates', 'Download accredited certificates')}</span></div>
                <div className="feature"><span className="check-icon">✓</span><span>{t('pricing.feature.shortTests', 'Take short tests (5 AI-generated questions)')}</span></div>
                <div className="feature"><span className="check-icon">✓</span><span>{t('pricing.feature.trackProgress', 'Track progress and certification history')}</span></div>
              </div>
              <button className="btn-pricing" onClick={() => window.location.href = 'https://cpd-pro.app/'}>
                {t('launchPlatform', 'Launch Platform')}
              </button>
            </div>
          </div>

          <div className="pricing-guarantee">
            <p>{t('pricing.secureStripe', 'Secure payment by Stripe')}</p>
          </div>
        </div>
      </section>
    </>
  );
}


